export const initialState = () => ({
  contractsListOptions: [],
  selectedContract: {}
})
